/**
 * Shared sx tokens for form controls inside the Setup tabs.
 *
 * The global Paper override paints backgrounds `#eeeeee`, so every
 * TextField/Select needs to override its own background back to white
 * or it disappears into the surface. Centralising the SX here keeps
 * that fix in one place.
 */
import { dsColorNew } from '@palette'

// Fields take the app's theme as they are (`Theme/overrides/Inputs.js`, `Theme/fields.js`): nothing to
// add. Kept as an empty token so the call sites read the same.
export const inputSx = {}

// Zebra + hover for enterprise-style tables. Even rows get a subtle
// grey wash; hover wins over both. Rows that need to override the bg
// for their own state (e.g. an amber "duplicate" warning) should set
// `bgcolor` only conditionally, leaving the zebra to show through
// otherwise — spread this sx first, then apply their conditional bg.
export const rowHoverSx = {
	'&:nth-of-type(even)': { bgcolor: dsColorNew.tableRowAlt },
	'&:hover': { bgcolor: dsColorNew.hoverBgLight },
	transition: 'background-color 120ms ease',
}

// Table cell padding — a bit more air than MUI's dense default.
export const cellPadSx = { py: 1.25, px: 1.5 }

// Small formatting for codes (SIPP, pricelist code, etc.), in the app's font as its other codes
export const codeSx = {
	fontFamily: 'inherit',
	fontSize: 12.5,
	color: dsColorNew.textDark,
	fontWeight: 600,
	bgcolor: dsColorNew.pillTrackBg,
	px: 0.75, py: 0.25,
	borderRadius: '6px',
	border: `1px solid ${dsColorNew.grayBorder}`,
	display: 'inline-block',
	lineHeight: 1.4,
}

// Table header cells: the theme already draws every `th` as the app's navy head (uppercase 12px, white,
// rounded outer corners — `Theme/overrides/Table.js`). Empty on purpose, so a DS Repricing table header
// is exactly the one of every other table.
export const headCellSx = {}
